import { gql } from '@apollo/client';

// Clinic Mutations
export const CREATE_CLINIC = gql`
  mutation CreateClinic($createClinicDto: CreateClinicDto!) {
    createClinic(createClinicDto: $createClinicDto) {
      id
      name_en
      name_zh_hk
      internal_name
      address
      phone_number
      email
      status
      region
      district
      description
      building_name
      floor
      unit
      postal_code
      website_url
      emergency_services
      walk_in_enabled
      online_consultation_enabled
      appointment_booking_enabled
      facilities
      services
      images
      latitude
      longitude
      created_at
      updated_at
    }
  }
`;

export const UPDATE_CLINIC = gql`
  mutation UpdateClinic($id: ID!, $updateClinicDto: UpdateClinicDto!) {
    updateClinic(id: $id, updateClinicDto: $updateClinicDto) {
      id
      name_en
      name_zh_hk
      internal_name
      address
      phone_number
      email
      status
      region
      district
      description
      building_name
      floor
      unit
      postal_code
      website_url
      emergency_services
      walk_in_enabled
      online_consultation_enabled
      appointment_booking_enabled
      facilities
      services
      images
      latitude
      longitude
      created_at
      updated_at
    }
  }
`;

export const DELETE_CLINIC = gql`
  mutation DeleteClinic($id: ID!) {
    deleteClinic(id: $id)
  }
`;

// Doctor Mutations
export const CREATE_DOCTOR = gql`
  mutation CreateDoctor($createDoctorDto: CreateDoctorDto!) {
    createDoctor(createDoctorDto: $createDoctorDto) {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      license_number
      specialization
      status
      rating
      experience_years
      consultation_fee
      avatar_url
      bio
      qualification
      title
      languages
      is_available_for_emergency
      max_daily_appointments
      total_reviews
      time_zone
      created_at
      updated_at
    }
  }
`;

export const UPDATE_DOCTOR = gql`
  mutation UpdateDoctor($id: ID!, $updateDoctorDto: UpdateDoctorDto!) {
    updateDoctor(id: $id, updateDoctorDto: $updateDoctorDto) {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      license_number
      specialization
      status
      rating
      experience_years
      consultation_fee
      avatar_url
      bio
      qualification
      title
      languages
      is_available_for_emergency
      max_daily_appointments
      total_reviews
      time_zone
      created_at
      updated_at
    }
  }
`;

export const DELETE_DOCTOR = gql`
  mutation DeleteDoctor($id: ID!) {
    deleteDoctor(id: $id)
  }
`;

// Patient Mutations
export const CREATE_PATIENT = gql`
  mutation CreatePatient($createPatientDto: CreatePatientDto!) {
    createPatient(createPatientDto: $createPatientDto) {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      birthdate
      gender
      status
      emergency_contact_name
      emergency_contact_phone
      avatar_url
      blood_type
      nationality
      identity_document_type
      identity_document_number
      language_preferences
      allergies
      chronic_conditions
      medications
      notes
      created_at
      updated_at
      app_user {
        id
        firstname
        lastname
        email
        phone_number
      }
    }
  }
`;

export const UPDATE_PATIENT = gql`
  mutation UpdatePatient($id: ID!, $updatePatientDto: UpdatePatientDto!) {
    updatePatient(id: $id, updatePatientDto: $updatePatientDto) {
      id
      first_name_en
      last_name_en
      first_name_zh_hk
      last_name_zh_hk
      email
      phone_number
      birthdate
      gender
      status
      emergency_contact_name
      emergency_contact_phone
      avatar_url
      blood_type
      nationality
      identity_document_type
      identity_document_number
      language_preferences
      allergies
      chronic_conditions
      medications
      notes
      created_at
      updated_at
      app_user {
        id
        firstname
        lastname
        email
        phone_number
      }
    }
  }
`;

export const DELETE_PATIENT = gql`
  mutation DeletePatient($id: ID!) {
    deletePatient(id: $id)
  }
`;

// Provider Mutations
export const CREATE_PROVIDER = gql`
  mutation CreateProvider($createProviderDto: CreateProviderDto!) {
    createProvider(createProviderDto: $createProviderDto) {
      id
      doctor_id
      clinic_id
      consultation_fee
      department
      employment_type
      start_date
      end_date
      status
      role
      specialization_at_clinic
      last_worked_at
      verified_at
      created_at
      updated_at
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        license_number
        specialization
        status
        rating
        experience_years
        email
        phone_number
      }
      clinic {
        id
        name_en
        name_zh_hk
        address
        region
        district
        phone_number
        email
        status
      }
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  mutation UpdateProvider($id: ID!, $updateProviderDto: UpdateProviderDto!) {
    updateProvider(id: $id, updateProviderDto: $updateProviderDto) {
      id
      doctor_id
      clinic_id
      consultation_fee
      department
      employment_type
      start_date
      end_date
      status
      role
      specialization_at_clinic
      last_worked_at
      verified_at
      created_at
      updated_at
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        license_number
        specialization
        status
        rating
        experience_years
        email
        phone_number
      }
      clinic {
        id
        name_en
        name_zh_hk
        address
        region
        district
        phone_number
        email
        status
      }
    }
  }
`;

export const DELETE_PROVIDER = gql`
  mutation DeleteProvider($id: ID!) {
    deleteProvider(id: $id)
  }
`;

// Provider Tag Mutations
export const ADD_TAG_TO_PROVIDER = gql`
  mutation AddTagToProvider($providerId: ID!, $tagId: ID!, $userId: ID) {
    addTagToProvider(providerId: $providerId, tagId: $tagId, userId: $userId)
  }
`;

export const REMOVE_TAG_FROM_PROVIDER = gql`
  mutation RemoveTagFromProvider($providerId: ID!, $tagId: ID!) {
    removeTagFromProvider(providerId: $providerId, tagId: $tagId)
  }
`;

// Schedule Mutations
export const CREATE_SCHEDULE = gql`
  mutation CreateSchedule($createScheduleDto: CreateScheduleDto!, $providerId: ID!) {
    createSchedule(createScheduleDto: $createScheduleDto, providerId: $providerId) {
      id
      provider_id
      status
      max_appointments_per_day
      default_appointment_duration
      is_available_for_telemedicine
      is_available_for_walk_in
      schedule {
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_SCHEDULE = gql`
  mutation UpdateSchedule($id: ID!, $updateScheduleDto: UpdateScheduleDto!) {
    updateSchedule(id: $id, updateScheduleDto: $updateScheduleDto) {
      id
      provider_id
      status
      max_appointments_per_day
      default_appointment_duration
      is_available_for_telemedicine
      is_available_for_walk_in
      schedule {
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_SCHEDULE = gql`
  mutation DeleteSchedule($id: ID!) {
    deleteSchedule(id: $id)
  }
`;

// Appointment Mutations
export const CREATE_APPOINTMENT = gql`
  mutation CreateAppointment($createAppointmentDto: CreateAppointmentDto!) {
    createAppointment(createAppointmentDto: $createAppointmentDto) {
      appointment {
        id
        app_user_id
        provider_id
        date
        time
        duration
        status
        type
        reservation_type
        questionnaire
        appointment_notes
        priority
        consultation_type
        language_preference
        booking_source
        payment_method
        total_amount
        insurance_claim_id
        timezone
        medical_history_reviewed
        patient_phone
        patient_email
        emergency_contact
        special_instructions
        tenant
        created_at
        updated_at
      }
      transaction {
        id
        appointment_id
        amount
        currency
        status
        payment_method
        transaction_reference
        gateway_transaction_id
        metadata
        created_at
        updated_at
      }
    }
  }
`;

export const UPDATE_APPOINTMENT = gql`
  mutation UpdateAppointment($id: String!, $updateAppointmentDto: UpdateAppointmentDto!) {
    updateAppointment(id: $id, updateAppointmentDto: $updateAppointmentDto) {
      id
      app_user_id
      provider_id
      date
      time
      duration
      status
      type
      reservation_type
      questionnaire
      appointment_notes
      internal_remark
      doctor_notes
      priority
      consultation_type
      language_preference
      booking_source
      payment_method
      total_amount
      insurance_claim_id
      timezone
      medical_history_reviewed
      patient_phone
      patient_email
      emergency_contact
      special_instructions
      tenant
      created_at
      updated_at
    }
  }
`;

export const DELETE_APPOINTMENT = gql`
  mutation DeleteAppointment($id: String!) {
    removeAppointment(id: $id) {
      id
      app_user_id
      provider_id
      date
      time
      duration
      status
      type
      reservation_type
      questionnaire
      appointment_notes
      priority
      consultation_type
      language_preference
      booking_source
      payment_method
      total_amount
      insurance_claim_id
      timezone
      medical_history_reviewed
      patient_phone
      patient_email
      emergency_contact
      special_instructions
      tenant
      created_at
      updated_at
    }
  }
`;

// Appointment Status Mutations
export const CONFIRM_APPOINTMENT = gql`
  mutation ConfirmAppointment($id: String!) {
    confirmAppointment(id: $id) {
      id
      status
      confirmed_at
      updated_at
    }
  }
`;

export const START_APPOINTMENT = gql`
  mutation StartAppointment($id: String!) {
    startAppointment(id: $id) {
      id
      status
      started_at
      updated_at
    }
  }
`;

export const DELETE_SF_EXPRESS_ORDER = gql`
  mutation DeleteSfExpressOrder($input: DeleteSfExpressOrderDto!) {
    deleteSfExpressOrder(input: $input)
  }
`;

export const DELETE_JD_EXPRESS_ORDER = gql`
  mutation DeleteJdExpressOrder($input: DeleteJdExpressOrderDto!) {
    deleteJdExpressOrder(input: $input)
  }
`;

export const COMPLETE_APPOINTMENT = gql`
  mutation CompleteAppointment($id: String!, $completionData: UpdateAppointmentDto) {
    completeAppointment(id: $id, completionData: $completionData) {
      id
      status
      completed_at
      updated_at
    }
  }
`;

export const CANCEL_APPOINTMENT = gql`
  mutation CancelAppointment($id: String!, $reason: String!, $cancelledBy: String!) {
    cancelAppointment(id: $id, reason: $reason, cancelledBy: $cancelledBy) {
      id
      status
      cancelled_at
      cancelled_reason
      cancelled_by
      updated_at
    }
  }
`;

export const MARK_APPOINTMENT_NO_SHOW = gql`
  mutation MarkAppointmentNoShow($id: String!) {
    markAppointmentNoShow(id: $id) {
      id
      status
      updated_at
    }
  }
`;

// Join Status Mutations
export const UPDATE_JOIN_STATUS = gql`
  mutation UpdateJoinStatus($id: String!, $status: String!) {
    updateJoinStatus(id: $id, status: $status) {
      id
      otherStatuses
      updated_at
    }
  }
`;


// Admin User Mutations
export const CREATE_ADMIN_USER = gql`
  mutation CreateAdminUser($createAdminUserDto: CreateAdminUserDto!) {
    createAdminUser(createAdminUserDto: $createAdminUserDto) {
      id
      email
      firstname
      lastname
      role_id
      permissions
      is_super_admin
      is_active
      phone_number
      avatar_url
      last_login_at
      last_login_ip
      created_at
      updated_at
      doctor_id
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        specialization
        license_number
      }
      clinic_id
      clinic {
        id
        name_en
        name_zh_hk
        address
        region
        district
        phone_number
        email
        status
      }
      userRole {
        id
        name
        description
        is_system_role
        is_active
        permissions {
          role_id
          permission
        }
      }
    }
  }
`;

export const UPDATE_ADMIN_USER = gql`
  mutation UpdateAdminUser($id: ID!, $updateAdminUserDto: UpdateAdminUserDto!) {
    updateAdminUser(id: $id, updateAdminUserDto: $updateAdminUserDto) {
      id
      email
      firstname
      lastname
      role_id
      permissions
      is_super_admin
      is_active
      phone_number
      avatar_url
      last_login_at
      last_login_ip
      created_at
      updated_at
      doctor_id
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        specialization
        license_number
      }
      clinic_id
      clinic {
        id
        name_en
        name_zh_hk
        address
        region
        district
        phone_number
        email
        status
      }
      userRole {
        id
        name
        description
        is_system_role
        is_active
        permissions {
          role_id
          permission
        }
      }
    }
  }
`;

export const DELETE_ADMIN_USER = gql`
  mutation DeleteAdminUser($id: ID!) {
    deleteAdminUser(id: $id)
  }
`;

export const ACTIVATE_ADMIN_USER = gql`
  mutation ActivateAdminUser($id: ID!) {
    activateAdminUser(id: $id) {
      id
      is_active
      updated_at
    }
  }
`;

export const DEACTIVATE_ADMIN_USER = gql`
  mutation DeactivateAdminUser($id: ID!) {
    deactivateAdminUser(id: $id) {
      id
      is_active
      updated_at
    }
  }
`;

export const RESET_ADMIN_USER_PASSWORD = gql`
  mutation ResetAdminUserPassword($id: ID!, $newPassword: String!) {
    resetAdminUserPassword(id: $id, newPassword: $newPassword) {
      success
      message
    }
  }
`;

// Admin Authentication Mutations
export const ADMIN_LOGIN = gql`
  mutation AdminLogin($loginDto: AdminLoginDto!) {
    adminLogin(loginDto: $loginDto) {
      adminUser {
        id
        email
        firstname
        lastname
        role
        role_id
        permissions
        is_super_admin
        is_active
        doctor_id
        userRole {
          id
          name
          description
          is_system_role
          is_active
          permissions {
            role_id
            permission
          }
        }
      }
      accessToken
      refreshToken
    }
  }
`;

export const ADMIN_ME = gql`
  query AdminMe {
    adminMe {
      id
      email
      firstname
      lastname
      role_id
      permissions
      is_super_admin
      is_active
      last_login_at
      last_login_ip
      doctor_id
      userRole {
        id
        name
        description
        is_system_role
        is_active
        permissions {
          role_id
          permission
        }
      }
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($changePasswordDto: ChangePasswordDto!) {
    changePassword(changePasswordDto: $changePasswordDto) {
      success
      message
    }
  }
`;

export const GET_ADMIN_USERS = gql`
  query GetAdminUsers {
    adminUsers {
      id
      email
      firstname
      lastname
      role_id
      permissions
      is_super_admin
      is_active
      phone_number
      avatar_url
      last_login_at
      last_login_ip
      created_at
      updated_at
      doctor_id
      doctor {
        id
        first_name_en
        last_name_en
        first_name_zh_hk
        last_name_zh_hk
        specialization
        license_number
      }
      clinic_id
      clinic {
        id
        name_en
        internal_name
        name_zh_hk
        address
        region
        district
        phone_number
        email
        status
      }
      userRole {
        id
        name
        description
        is_system_role
        is_active
        permissions {
          role_id
          permission
        }
      }
    }
  }
`;

export const ADMIN_REFRESH_TOKEN = gql`
  mutation AdminRefreshToken($refreshToken: String!) {
    adminRefreshToken(refreshToken: $refreshToken) {
      adminUser {
        id
        email
        firstname
        lastname
        role
        permissions
        is_super_admin
        is_active
        doctor_id
      }
      accessToken
      refreshToken
    }
  }
`;

// Admin User Role Mutations
export const CREATE_ADMIN_USER_ROLE = gql`
  mutation CreateAdminUserRole($createAdminUserRoleDto: CreateAdminUserRoleDto!) {
    createAdminUserRole(createAdminUserRoleDto: $createAdminUserRoleDto) {
      id
      name
      description
      is_system_role
      is_active
      created_at
      updated_at
      permissions {
        role_id
        permission
      }
    }
  }
`;

export const UPDATE_ADMIN_USER_ROLE = gql`
  mutation UpdateAdminUserRole($id: ID!, $updateAdminUserRoleDto: UpdateAdminUserRoleDto!) {
    updateAdminUserRole(id: $id, updateAdminUserRoleDto: $updateAdminUserRoleDto) {
      id
      name
      description
      is_system_role
      is_active
      created_at
      updated_at
      permissions {
        role_id
        permission
      }
    }
  }
`;

export const DELETE_ADMIN_USER_ROLE = gql`
  mutation DeleteAdminUserRole($id: ID!) {
    deleteAdminUserRole(id: $id)
  }
`;

// Admin User Role Queries
export const GET_ADMIN_USER_ROLES = gql`
  query GetAdminUserRoles {
    adminUserRoles {
      id
      name
      description
      is_system_role
      is_active
      created_at
      updated_at
      permissions {
        role_id
        permission
      }
    }
  }
`;

export const GET_ADMIN_USER_ROLE = gql`
  query GetAdminUserRole($id: ID!) {
    adminUserRole(id: $id) {
      id
      name
      description
      is_system_role
      is_active
      created_at
      updated_at
      permissions {
        role_id
        permission
      }
    }
  }
`;

export const GET_ADMIN_USER_ROLE_PERMISSIONS = gql`
  query GetAdminUserRolePermissions {
    adminUserRolePermissions {
      role_id
      permission
    }
  }
`;

export const GET_AVAILABLE_ADMIN_PERMISSIONS = gql`
  query GetAvailableAdminPermissions {
    availableAdminPermissions
  }
`;

// Transaction Mutations
export const CREATE_TRANSACTION = gql`
  mutation CreateTransaction($createTransactionDto: CreateTransactionDto!) {
    createTransaction(createTransactionDto: $createTransactionDto) {
      id
      app_user_id
      appointment_id
      transaction_reference
      amount
      currency
      type
      status
      payment_method
      description
      category
      subcategory
      notes
      gateway_transaction_id
      gateway_response
      processing_fee
      tax_amount
      discount_amount
      final_amount
      metadata
      refund_reason
      refunded_by
      refunded_at
      original_transaction_id
      created_at
      updated_at
      processed_at
      completed_at
    }
  }
`;

export const UPDATE_TRANSACTION = gql`
  mutation UpdateTransaction($id: String!, $updateTransactionDto: UpdateTransactionDto!) {
    updateTransaction(id: $id, updateTransactionDto: $updateTransactionDto) {
      id
      app_user_id
      appointment_id
      transaction_reference
      amount
      currency
      type
      status
      payment_method
      description
      category
      subcategory
      notes
      gateway_transaction_id
      gateway_response
      processing_fee
      tax_amount
      discount_amount
      final_amount
      metadata
      refund_reason
      refunded_by
      refunded_at
      original_transaction_id
      created_at
      updated_at
      processed_at
      completed_at
    }
  }
`;

export const DELETE_TRANSACTION = gql`
  mutation DeleteTransaction($id: String!) {
    removeTransaction(id: $id) {
      id
      app_user_id
      appointment_id
      transaction_reference
      amount
      currency
      type
      status
      payment_method
      description
      category
      subcategory
      notes
      gateway_transaction_id
      gateway_response
      processing_fee
      tax_amount
      discount_amount
      final_amount
      metadata
      refund_reason
      refunded_by
      refunded_at
      original_transaction_id
      created_at
      updated_at
      processed_at
      completed_at
    }
  }
`;

// App User Mutations
export const CREATE_APP_USER = gql`
  mutation CreateAppUser($createUserDto: CreateUserDto!) {
    createUser(createUserDto: $createUserDto) {
      id
      email
      firstname
      lastname
      phone_number
      tenant
      language_preference
      ic_type
      ic_number
      birthdate
      age
      gender
      created_at
      updated_at
      deleted_at
      deleted_reason
    }
  }
`;

// Note: updateUser mutation doesn't exist in backend yet
// export const UPDATE_APP_USER = gql`
//   mutation UpdateAppUser($id: ID!, $updateUserDto: UpdateUserDto!) {
//     updateUser(id: $id, updateUserDto: $updateUserDto) {
//       id
//       email
//       firstname
//       lastname
//       phone_number
//       tenant
//       language_preference
//       ic_type
//       ic_number
//       birthdate
//       age
//       gender
//       created_at
//       updated_at
//       deleted_at
//       deleted_reason
//     }
//   }
// `;

export const DELETE_APP_USER = gql`
  mutation DeleteAppUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const SOFT_DELETE_APP_USER = gql`
  mutation SoftDeleteAppUser($softDeleteUserDto: SoftDeleteUserDto!) {
    softDeleteUser(softDeleteUserDto: $softDeleteUserDto) {
      success
      message
    }
  }
`;

export const RESTORE_APP_USER = gql`
  mutation RestoreAppUser($id: ID!) {
    restoreUser(id: $id) {
      success
      message
    }
  }
`;

// SF Express Cloud Print Waybill Mutations
export const CLOUD_PRINT_SF_EXPRESS_WAYBILL = gql`
  mutation CloudPrintSfExpressWaybill($input: SfExpressCloudPrintWaybillInput!) {
    cloudPrintSfExpressWaybill(input: $input) {
      success
      errorCode
      errorMsg
      data {
        waybillNo
        pdfUrl
        pdfBase64
        templateCode
        fileSize
        generateTime
      }
    }
  }
`;

export const CLOUD_PRINT_SF_EXPRESS_WAYBILLS_BATCH = gql`
  mutation CloudPrintSfExpressWaybillsBatch($inputs: [SfExpressCloudPrintWaybillInput!]!) {
    cloudPrintSfExpressWaybillsBatch(inputs: $inputs) {
      success
      errorCode
      errorMsg
      data {
        waybillNo
        pdfUrl
        pdfBase64
        templateCode
        fileSize
        generateTime
      }
    }
  }
`;

// JD Express Precheck Mutation
export const PRECHECK_JD_EXPRESS_ORDER = gql`
  mutation PrecheckJdExpressOrderFromAppointment($input: CreateJdExpressOrderFromAppointmentDto!) {
    precheckJdExpressOrderFromAppointment(input: $input) {
      success
      errorCode
      errorMsg
      data {
        totalFreightPre
        currency
        calWeight
        totalAmount
        deliveryPromiseTime
        productCode
        productName
        freightPre
        startStationName
        endStationName
        startStationCode
        endStationCode
      }
    }
  }
`;

// JD Express Cloud Print Waybill Mutation
export const CLOUD_PRINT_JD_EXPRESS_WAYBILL = gql`
  mutation CloudPrintJdExpressWaybill($input: JdExpressCloudPrintWaybillInput!) {
    cloudPrintJdExpressWaybill(input: $input) {
      success
      errorCode
      errorMsg
      data {
        waybillNo
        pdfUrl
        pdfBase64
        templateCode
        fileSize
        generateTime
      }
    }
  }
`;

// Address Mutations
export const CREATE_ADDRESS = gql`
  mutation CreateAddress($createAddressDto: CreateAddressDto!) {
    createAddress(createAddressDto: $createAddressDto) {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  mutation UpdateAddress($id: ID!, $updateAddressDto: UpdateAddressDto!) {
    updateAddress(id: $id, updateAddressDto: $updateAddressDto) {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
  }
`;

export const DELETE_ADDRESS = gql`
  mutation DeleteAddress($id: ID!) {
    deleteAddress(id: $id)
  }
`;

export const SET_DEFAULT_ADDRESS = gql`
  mutation SetDefaultAddress($addressId: ID!) {
    setDefaultAddress(addressId: $addressId) {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
  }
`;

// Admin Address Mutations
export const ADMIN_CREATE_ADDRESS = gql`
  mutation AdminCreateAddress($createAddressDto: CreateAddressDto!) {
    adminCreateAddress(createAddressDto: $createAddressDto) {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
  }
`;

export const ADMIN_UPDATE_ADDRESS = gql`
  mutation AdminUpdateAddress($id: ID!, $updateAddressDto: UpdateAddressDto!) {
    adminUpdateAddress(id: $id, updateAddressDto: $updateAddressDto) {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
  }
`;

export const ADMIN_DELETE_ADDRESS = gql`
  mutation AdminDeleteAddress($id: ID!) {
    adminDeleteAddress(id: $id)
  }
`;

export const ADMIN_SET_DEFAULT_ADDRESS = gql`
  mutation AdminSetDefaultAddress($addressId: ID!) {
    adminSetDefaultAddress(addressId: $addressId) {
      id
      type
      display_name
      region
      district
      street_address
      building_name
      floor
      block
      unit
      postal_code
      override_address
      is_default
      phone_number
      contact_name
      created_at
      updated_at
    }
  }
`;

// Insurance Policy Mutations
export const CREATE_INSURANCE_POLICY = gql`
  mutation CreateInsurancePolicy($createInsurancePolicyDto: CreateInsurancePolicyDto!) {
    createInsurancePolicy(createInsurancePolicyDto: $createInsurancePolicyDto) {
      id
      name
      payor
      planId
      policyNumber
      startDate
      endDate
      appUserId
      description
      policyDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
      isActive
      createdAt
      updatedAt
      plan {
        id
        name
        payor
        description
        planDetails {
          free_consultations
          free_consultations_per_year
          free_consultations_per_month
          free_consultations_per_week
        }
      }
      appUser {
        id
        firstname
        lastname
        email
        phone_number
      }
    }
  }
`;

export const UPDATE_INSURANCE_POLICY = gql`
  mutation UpdateInsurancePolicy($id: ID!, $updateInsurancePolicyDto: UpdateInsurancePolicyDto!) {
    updateInsurancePolicy(id: $id, updateInsurancePolicyDto: $updateInsurancePolicyDto) {
      id
      name
      payor
      planId
      policyNumber
      startDate
      endDate
      appUserId
      description
      policyDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
      isActive
      createdAt
      updatedAt
      plan {
        id
        name
        payor
        description
        planDetails {
          free_consultations
          free_consultations_per_year
          free_consultations_per_month
          free_consultations_per_week
        }
      }
      appUser {
        id
        firstname
        lastname
        email
        phone_number
      }
    }
  }
`;

export const CREATE_INSURANCE_CLAIM = gql`
  mutation CreateInsuranceClaim($createInsuranceClaimResultDto: CreateInsuranceClaimResultDto!) {
    createInsuranceClaimResult(createInsuranceClaimResultDto: $createInsuranceClaimResultDto) {
      id
      policyId
      appointmentId
      status
      items {
        id
        name
        category
        amount
        approvedAmount
        transactionId
      }
    }
  }
`;

export const BATCH_CREATE_INSURANCE_COUPONS = gql`
  mutation BatchCreateInsuranceCoupons($batchCreateInsuranceCouponsDto: BatchCreateInsuranceCouponsDto!) {
    batchCreateInsuranceCoupons(batchCreateInsuranceCouponsDto: $batchCreateInsuranceCouponsDto) {
      id
      payor
      couponCode
      startDate
      endDate
      appUserId
      appointmentId
      policyDetails {
        free_consultations
        free_consultations_per_year
        free_consultations_per_month
        free_consultations_per_week
      }
      isActive
      createdAt
      updatedAt
      plan {
        id
        name
        payor
        description
      }
    }
  }
`;

export const UPDATE_INSURANCE_CLAIM = gql`
  mutation UpdateInsuranceClaim($id: ID!, $updateInsuranceClaimResultDto: UpdateInsuranceClaimResultDto!) {
    updateInsuranceClaimResult(id: $id, updateInsuranceClaimResultDto: $updateInsuranceClaimResultDto) {
      id
      policyId
      appointmentId
      status
      items {
        id
        name
        category
        amount
        approvedAmount
        transactionId
      }
    }
  }
`; 